import pako from 'pako';
import base64js from 'base64-js';

export const compressContent = (content: string): string => {
  try {
    // Convert string to Uint8Array
    const textEncoder = new TextEncoder();
    const contentBytes = textEncoder.encode(content);

    // Compress the bytes
    const compressed = pako.deflate(contentBytes, { level: 9 });

    // Convert compressed bytes to base64 string for storage
    return base64js.fromByteArray(compressed);
  } catch (error) {
    console.error('Compression error:', error);
    // Return original content if compression fails
    return content;
  }
};

export const decompressContent = (compressed: string): string => {
  try {
    // Convert base64 string back to Uint8Array
    const compressedBytes = base64js.toByteArray(compressed);

    // Decompress the bytes
    const decompressed = pako.inflate(compressedBytes);

    // Convert Uint8Array back to string
    const textDecoder = new TextDecoder();
    return textDecoder.decode(decompressed);
  } catch (error) {
    console.error('Decompression error:', error);
    // Return compressed content if decompression fails
    return compressed;
  }
};

export const shouldCompress = (content: string): boolean => {
  // Only compress content longer than 1KB
  return content.length > 1024;
};